import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ImpFlyout } from '../..';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpPad from '../../Atoms/ImpPad/ImpPad';
import { colors } from '../../DesignSystem/colors';
import { zIndex } from '../../DesignSystem/zIndex';
import { Icons } from '../../Icons/Icons';
import ImpIcon from '../../Molecules/ImpIcon/ImpIcon';
import { useModal } from '../../Molecules/ImpModal/ImpModal';
import ImpText from '../../Molecules/ImpText/ImpText';
import { Logo, LogoNoText } from './Logo';
const DesktopNavContainer = styled.div `
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: row;

  ${({ navStyle }) => navStyle === 'top' &&
    `
    flex-direction: column;
  `}
`;
const NavSectionContainer = styled.div `
  position: sticky;
  top: 0px;
  z-index: ${zIndex.nav};
  height: 100%;
  overflow-y: auto;
  max-width: 16rem;
  min-width: 16rem;
  width: 16rem;
  border-right: 1px solid rgb(219, 218, 201);
  background-color: ${colors.surface.surfaceHigh};
  transform: translateX(-100%);
  transition-property: min-width, transform, width;
  transition-duration: 0.14s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);

  transform: translateX(0%);

  ${({ navStyle }) => navStyle === 'small' &&
    `
      min-width: 4.25rem;
      max-width: 4.25rem;
      width: 4.25rem;
  `}

  ${({ navStyle }) => navStyle === 'top' &&
    `
    border-right: none;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
      transition: top 0.2s ease-in 0s;
      background-color: green;

  `}
`;
const ContentContainer = styled.div `
  width: 100%;
  flex: 1 1 0%;
  min-width: 0px;
`;
const Header = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-basis: auto;
  max-width: 100%;
  width: 100%;
  padding: 24px 12px;

  * {
    display: flex;
    align-items: center;
  }

  & > :first-child {
    flex-grow: 1;
    justify-content: flex-start;
    width: 100%;
  }
`;
const HeaderSmall = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 24px 0px;
`;
const Content = styled.div `
  min-width: 0px;
  flex-grow: 1;
  flex-basis: 0%;
  width: 100%;

  display: flex;
  align-items: stretch;

  flex-direction: column;
`;
const NavContentContainerDesktop = styled.div `
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 0rem;
  flex-grow: 1;
  max-width: 100%;

  ${({ navStyle }) => navStyle === 'top' &&
    `
      display: none;
  `}
`;
const NavContentContainerMobile = styled.div `
  padding: 0px 16px;
  flex-direction: row;
  height: 60px;
  background-color: ${colors.surface.surfaceHigh};
  align-items: center;
  justify-content: space-between;

  display: none;

  ${({ navStyle }) => navStyle === 'top' &&
    `
      display: flex;
      border-bottom: 1px solid ${colors.border.borderVariant};
  `}
`;
export function ImpDesktopNav({ items, trailingContent, children, }) {
    const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
    const [isOverlayOpen, isOverlayClosing, openOverlay, closeOverlay] = useModal(false);
    const [isFlyoutOpen, isFlyoutClosing, openFlyout, closeFlyout] = useModal(false);
    const [internalNavStyle, setInternalNavStyle] = React.useState(null);
    const [isMouseEntered, setIsMouseEntered] = React.useState(false);
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            setInternalNavStyle(null);
            if (isOverlayOpen && window.innerWidth > 600) {
                closeOverlay();
            }
            if (isFlyoutOpen && window.innerWidth > 1000) {
                closeFlyout();
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isOverlayOpen, isFlyoutOpen]);
    const defaultNav = getNavStyle(screenWidth);
    const handleNavIconClick = () => {
        if (defaultNav === 'small') {
            if (isFlyoutOpen) {
                closeFlyout();
                return;
            }
            openFlyout();
            return;
        }
        setInternalNavStyle((prev) => {
            if (prev === 'small') {
                return 'large';
            }
            if (prev === 'large') {
                return 'small';
            }
            if (prev === 'top') {
                return 'large';
            }
            if (prev === null) {
                return getNavStyle(screenWidth) === 'small' ? 'large' : 'small';
            }
            return null;
        });
    };
    const isMobile = screenWidth < 600;
    const navStyle = isMobile ? 'top' : internalNavStyle || defaultNav;
    useEffect(() => {
        if (isOverlayOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOverlayOpen]);
    const itemsFromStyle = (relevantStyle) => items.map((item, i) => (React.createElement(NavListItem, { onClick: () => {
            if (isFlyoutOpen) {
                closeFlyout();
            }
            if (isOverlayOpen) {
                closeOverlay();
            }
            item.onClick();
        } }, relevantStyle === 'large' ? (React.createElement(NavItemLarge, null,
        React.createElement(ImpIcon, { iconSrc: item.iconSrc, size: "20px" }),
        React.createElement(ImpText, { typography: "body2" }, item.label))) : (React.createElement(NavItemIcon, null,
        React.createElement(ImpIcon, { iconSrc: item.iconSrc }))))));
    const LargeHeader = () => (React.createElement(Header, null,
        React.createElement("div", null,
            React.createElement(Logo, null)),
        React.createElement("div", null,
            React.createElement(ImpIcon, { iconSrc: Icons.arrowLineLeft, onClick: handleNavIconClick }))));
    const TrailingContent = () => (React.createElement(ImpContainer, { borderTop: `1px solid ${colors.border.borderVariant}`, width: "100%" },
        React.createElement(ImpPad, { padding: "16px" },
            React.createElement(ImpFlex, { direction: "column", align: "flex-start", gap: "8px", fluid: true },
                React.createElement(ImpText, { overflowStyle: "ellipsis" }, trailingContent.leading),
                React.createElement(ImpText, { overflowStyle: "ellipsis" }, trailingContent.trailing)))));
    const mobileItems = items.map((item, i) => (React.createElement(NavListItemMobile, { onClick: () => {
            if (isOverlayOpen) {
                closeOverlay();
            }
            item.onClick();
        } },
        React.createElement(ImpIcon, { iconSrc: item.iconSrc, size: "20px" }),
        React.createElement(ImpText, { typography: "body2" }, item.label))));
    return (React.createElement(DesktopNavContainer, { navStyle: navStyle },
        React.createElement(NavSectionContainer, { navStyle: navStyle, onMouseEnter: () => setIsMouseEntered(true), onMouseLeave: () => setIsMouseEntered(false) },
            React.createElement(NavContentContainerDesktop, { navStyle: navStyle },
                navStyle === 'large' ? (React.createElement(LargeHeader, null)) : (React.createElement(HeaderSmall, null, isMouseEntered ? (React.createElement(ImpIcon, { iconSrc: Icons.arrowLineRight, onClick: handleNavIconClick })) : (React.createElement(LogoNoText, null)))),
                React.createElement(Content, null, itemsFromStyle(navStyle)),
                navStyle === 'large' && (React.createElement(ProfileSection, null,
                    React.createElement(ImpText, { overflowStyle: "ellipsis" }, trailingContent.leading),
                    React.createElement(ImpText, { overflowStyle: "ellipsis" }, trailingContent.trailing)))),
            React.createElement(NavContentContainerMobile, { navStyle: navStyle },
                React.createElement(Logo, null),
                React.createElement(ImpIcon, { size: "20px", iconSrc: isOverlayOpen ? Icons.close : Icons.list, onClick: isOverlayOpen ? closeOverlay : openOverlay }))),
        defaultNav === 'small' && (React.createElement(ImpFlyout, { isOpen: isFlyoutOpen, isClosing: isFlyoutClosing, close: closeFlyout, from: "left", padDefault: false, width: "min(256px, 100%)", hideNav: true },
            React.createElement(NavSectionContainer, { navStyle: "large" },
                React.createElement(NavContentContainerDesktop, { navStyle: 'large' },
                    React.createElement(LargeHeader, null),
                    React.createElement(Content, null, itemsFromStyle('large')),
                    React.createElement(ProfileSection, null,
                        React.createElement(ImpText, { overflowStyle: "ellipsis" }, trailingContent.leading),
                        React.createElement(ImpText, { overflowStyle: "ellipsis" }, trailingContent.trailing)))))),
        navStyle === 'top' && (React.createElement(React.Fragment, null,
            React.createElement(TopDrawer, { isOpen: isOverlayOpen, isClosing: isOverlayClosing },
                React.createElement(ImpFlex, { direction: "column", fluid: true, justify: "space-between" },
                    React.createElement(ImpFlex, { direction: "column", fluid: true }, mobileItems),
                    React.createElement(TrailingContent, null))))),
        React.createElement(ContentContainer, null,
            React.createElement(ImpFlex, { direction: "column", gap: "xl" }, children))));
}
const getNavStyle = (screenWidth) => {
    if (screenWidth < 600) {
        return 'top';
    }
    else if (screenWidth < 1000) {
        return 'small';
    }
    else {
        return 'large';
    }
};
const NavItemLarge = styled.div `
  &:hover {
    background-color: ${colors.surface.surfaceLow};
  }
  &:active {
    background-color: ${colors.surface.surfaceMid};
  }

  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 12px 24px;
`;
const NavItemIcon = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 0 12px 24px;
`;
const ProfileSection = styled.div `
  border-top: 1px solid ${colors.border.borderVariant};
  display: flex;
  position: sticky;
  bottom: 0px;
  flex-direction: column;
  flex-basis: auto;
  flex-direction: column;
  padding: 24px;
  gap: 8px;

  background-color: ${colors.surface.surfaceMid};
`;
const NavListItem = styled.div `
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: ${colors.surface.surfaceLow};
  }

  display: flex;
  align-items: center;
  height: 48px;

  &:active {
    background-color: ${colors.surface.surfaceMid};
  }
`;
const NavListItemMobile = styled.div `
  cursor: pointer;
  user-select: none;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border-bottom: 1px solid ${colors.border.borderVariant};
  &:hover {
    background-color: ${colors.surface.surfaceLow};
  }

  &:active {
    background-color: ${colors.surface.surfaceMid};
  }
`;
const TopDrawer = styled.div `
  z-index: ${zIndex.nav};
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 61px;
  overflow: hidden;
  background-color: ${colors.surface.surfaceMid};
  opacity: 0;
  transition: transform 0.1s ease-in-out, opacity 0.1s ease-in-out;
  transform: translateY(1%);
  ${({ isOpen }) => isOpen &&
    `
    transform: translateY(0%);
    opacity: 1;
  `}
  ${({ isClosing }) => isClosing &&
    `
    transform: translateY(1%);
    opacity: 0;
  `};
`;
//# sourceMappingURL=ImpDesktopNav.js.map